import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import QuestionCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/QuestionCircleOutlined";
import AntdIcon from "../components/AntdIcon";
var QuestionCircleOutlined = function QuestionCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: QuestionCircleOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(QuestionCircleOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'QuestionCircleOutlined';
}
export default RefIcon;